import React from 'react';
import { FieldError } from 'react-hook-form';

import { Textarea } from '@jobandtalent/design-system';

export const reasonRules = {
  validate: (value: string) =>
    value.trim().length >= 25 || 'Reason must be at least 25 characters.'
};

export const optionalReasonRules = {
  validate: (value: string) => !value.trim() || reasonRules.validate(value)
};

const ReasonField = ({
  value,
  onChange,
  inputRef,
  error,
  placeholder,
  append = false,
  disabled = false
}: {
  value: string;
  onChange: (value: string) => void;
  inputRef: React.Ref<unknown>;
  error?: FieldError;
  placeholder: string;
  append?: boolean;
  disabled?: boolean;
}) => (
  <>
    <Textarea
      ref={inputRef}
      id="assignment-reason"
      name="reason"
      label={append ? 'Additional reason (optional, minimum 25 characters)' : 'Reason (minimum 25 characters)'}
      height={120}
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onChange={({ value: reason }) => onChange(reason)}
      error={error?.message}
    />
    {append && <p>Enter only the new reason text. It will be appended to the saved reason.</p>}
  </>
);

export default ReasonField;
